import React, { useContext, useEffect, useRef } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";
import { CursorContext } from "../context/CursorContext";
import Image from "../img/404/Scarecrow.png";
import { BsArrowRight } from "react-icons/bs";
import Footer from "../components/Footer";
import { ScrollLink } from "../components/ScrollLink";

export default function CstmNotFound() {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const scrollRef = useRef(null);
  useEffect(() => {
    // 🧩 Set the default scroller for GSAP's ScrollTrigger to the custom scroll container
    ScrollTrigger.defaults({
      scroller: scrollRef.current,
    });

    // 🧩 Refresh all ScrollTriggers (in case layout changes)
    ScrollTrigger.refresh();
  }, []);

  // 🧩 Animation variant for fade-up effect on mount
  // const fadeUp = {
  //   hidden: { opacity: 0, y: 40 },
  //   visible: (i = 1) => ({
  //     opacity: 1,
  //     y: 0,
  //     transition: {
  //       delay: i * 0.15,
  //       duration: 0.7,
  //       ease: "easeOut",
  //     },
  //   }),
  // };

  return (
    <motion.section
      id="about"
      className="section snap-start min-h-screen flex flex-col lg:pt-36 pt-24 pb-24"
      initial={{ opacity: 0, y: "5%" }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false, amount: 0.2 }}
      exit={{ opacity: 0, y: "5%" }}
      transition={transition1}
      onMouseEnter={mouseEnterHandler} // 🧩 Custom cursor hover effect: on enter
      onMouseLeave={mouseLeaveHandler} // 🧩 Custom cursor hover effect: on leave
    >
      <div className="container mx-auto px-4 flex flex-col lg:flex-row h-full justify-center items-center">
        <picture className="flex justify-center items-center lg:w-1/2">
          <img src={Image} alt="scarecrow" className="w-11/12 h-auto" />
        </picture>

        <div className="flex justify-center flex-col items-center text-center lg:w-1/2 mt-6 lg:mt-0">
          {/* 🧩 Main 404 error message */}
          <h2 className="text-4xl lg:text-5xl font-normal tracking-wide uppercase pt-4">
            404... UH OH! You're lost.
          </h2>

          {/* 🧩 CTA button to navigate back to home */}
          <div className="w-full flex justify-center mt-6 mb-2">
            <ScrollLink section="home" className="btn">
              Home
              <span>
                <BsArrowRight />
              </span>
            </ScrollLink>
          </div>
        </div>

        {/* 🧩 Footer section shown on all pages */}
        <Footer />
      </div>
    </motion.section>
  );
}
